<template>
  <div class="terms">
    <h2 class="terms__title">條款</h2>
    <div class="box">
      <div class="box__header">
        <h2>方案選擇</h2>
      </div>
      <div class="box__content">
        <p>
          我們收集資訊是為了向所有使用者提供更優質的服務；
          這些資訊可協助我們判斷基本設定 (例如您使用的語言、日期型式)，甚至分析更複雜的內容。
          我們收集資訊的方式有兩種：
          您提供的資訊。在您申請註冊帳號的過程中，我們會請您提供電話號碼。
          如果您是使用 facebook 帳號進行登入，我們會收集您所允許本系統使用之資料，例如您的姓名和電子郵件位址等。
          我們經由您對本軟體的使用而取得的資訊。
          我們會針對您使用的服務和使用方式收集相關資訊，例如您送出的訂單所包含之品項及訂單資訊(如訂單時間、付款方式等)。
          當您送出訂單時，我們同時會記錄您當時所使用裝置之代碼(Device Token)，這個代碼是一連串的數字，不帶有任何與您個人相關的訊息。
          記錄此項代碼的目的是為了當訂單完成時我們可以推送相關訊息至該裝置。
          我們收集資訊是為了向所有使用者提供更優質的服務；
          這些資訊可協助我們判斷基本設定 (例如您使用的語言、日期型式)，甚至分析更複雜的內容。
          我們收集資訊的方式有兩種：碼的目的是為了當訂單完成時我們可以推送相關訊息至該裝置。
        </p>
      </div>
    </div>
    <div class="box">
      <div class="box__header">
        <h2>資料分享與揭露</h2>
      </div>
      <div class="box__content">
        <p>
          除非適用以下任何一種情況，否則我們不會向任何其他人士或非關係企業出借或出售您的個人資料，或與之分享：
          事先徵得您的同意。我們只會在徵得您的同意時，才與微碧愛普科技以外的其他公司、機構或個人分享個人資訊。
          分享任何敏感的個人資訊前，我們都會先徵求您的同意。
          供外部處理。我們向已簽署保密協議書之代表微碧愛普科技執行業務或與我們共事的值得信賴的合作夥伴提供這些資料。
          這些公司可能會將您的個人資料用於協助微碧愛普科技就我們和行銷夥伴所提供產品及服務的事宜，與您進行溝通。
          但這些公司無獨立權利分享這些資料。廣告行為。在您瀏覽精準式行銷廣告或與廣告發生互動時，
          微碧愛普科技不會向廣告主提供您的任何個人資料。然而，一旦瀏覽廣告或與廣告發生互動，
          即表示您同意廣告主可能會假定您符合展示型廣告所使用的精準式行銷標準。
          基於法律原因。我們對傳票、法院命令或法律程序作出回應、取得或行使法律權利，或對訴訟上之請求提出防禦。
          我們認為為了調查和防止非法活動、涉嫌詐欺、對人身安全有潛在威脅的狀況、對微碧愛普科技服務條款的違反，
          或為了對上述情形採取應對措施，或法律另有規定，而有必要分享您的個人資料時。
          收購或合併。如果微碧愛普科技被其他公司收購或合併，我們會將您的個人資料移轉給該公司。
          如果發生這種情況，微碧愛普科技會在您的個人資料被移轉且將適用不同的隱私權政策前通知您。
          基於法律原因。我們對傳票、法院命令或法律程序作出回應、取得或行使法律權利，或對訴訟上之請求提出防禦。
          我們認為為了調查和防止非法活動、涉嫌詐欺、對人身安全有潛在威脅的狀況、對微碧愛普科技服務條款的違反，
          或為了對上述情形採取應對措施，或法律另有規定，而有必要分享您的個人資料時。
          收購或合併。如果微碧愛普科技被其他公司收購或合併，我們會將您的個人資料移轉給該公司。
          如果發生這種情況，微碧愛普科技會在您的個人資料被移轉且將適用不同的隱私權政策前通知您。
        </p>
      </div>
    </div>
    <div class="terms__footer">
      <b-checkbox v-model="termsAgreed" @input="onAgree">
        我已閱讀並接受本同意書之所有內容及其後修改變更規定。
      </b-checkbox>
    </div>
  </div>
</template>

<script>
import Terms from './Terms';

export default Terms;
</script>

<style lang="scss" scoped>
@import 'Terms';
</style>
